// extracted by mini-css-extract-plugin
export var animate = "index-module--animate--vGfwk";
export var arrowGroup = "index-module--arrowGroup--LSaKe";
export var arrows = "index-module--arrows--0cbha";